import React from 'react'
import DocCode from "../DocCode"

const Bages = () => {

    // {/* x---------------------------------x Bages Code Section x---------------------------------x */}
    const BagesCode =
        `
        <div className="flex items-center justify-center bg-white p-8">
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-4">

                <span className="inline-flex items-center rounded-lg bg-gray-50 px-2 py-1 text-balance font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-red-50 px-2 py-1 text-balance font-medium text-red-700 ring-1 ring-inset ring-red-600/10">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-yellow-50 px-2 py-1 text-balance font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-green-50 px-2 py-1 text-balance font-medium text-green-700 ring-1 ring-inset ring-green-600/20">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-blue-50 px-2 py-1 text-balance font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-indigo-50 px-2 py-1 text-balance font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-purple-50 px-2 py-1 text-balance font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">Badge</span>
                <span className="inline-flex items-center rounded-lg bg-pink-50 px-2 py-1 text-balance font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">Badge</span>

            </div>
        </div>
        `

    // {/* x---------------------------------x Bages Preview Section x---------------------------------x */}
    const BagesPreview = (
        <>
            <div className="border rounded-md relative  bg-gray-50">
                <div className="flex items-center justify-center p-8">
                    <div className="flex flex-wrap justify-center gap-x-6 gap-y-4">

                        <span className="inline-flex items-center rounded-lg bg-gray-50 px-5 py-2 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-red-50 px-5 py-2 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-yellow-50 px-5 py-2 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-green-50 px-5 py-2 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-blue-50 px-5 py-2 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-indigo-50 px-5 py-2 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-purple-50 px-5 py-2 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">Badge</span>
                        <span className="inline-flex items-center rounded-lg bg-pink-50 px-5 py-2 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">Badge</span>

                    </div>
                </div>
            </div>
        </>
    )

    return (
        // {/* x---------------------------------x DocCode Component Section x---------------------------------x */}s
        <DocCode
            heading={"Badges"}
            headingText={"Use these Tailwind CSS badge components to highlight important information, statuses, or counts in your application. These badges are designed and built by the Tailwind CSS team, and include a variety of different styles."}
            Preview={BagesPreview}
            code={BagesCode}
        />

    )
}

export default Bages;